<!-- Recuperar contraseña con el diseño del inicio de sesión -->
<div class="login-experience">
  <aside class="login-story">
    <a routerLink="/login" class="login-wordmark" aria-label="Innporting"><img src="assets/img/innporting-logo.svg" alt=""><span class="innporting-wordmark">Innporting</span></a>
    <img class="login-backdrop" src="assets/img/pages/login/login-background.jpg" alt="" aria-hidden="true">
    <div class="story-copy">
      <span class="story-eyebrow">{{'REDESIGN.LOGIN_EYEBROW' | translate}}</span>
      <h1>{{'REDESIGN.LOGIN_TITLE' | translate}}</h1>
      <p>{{'REDESIGN.LOGIN_DESC' | translate}}</p>
    </div>
    <div class="story-bottom"><span><i></i>{{'REDESIGN.LOGIN_FEATURE' | translate}}</span></div>
  </aside>
  <main class="login-main">
    <div class="login-top"><app-language-switch-item></app-language-switch-item><a routerLink="/register">{{'HEADER.REGISTER' | translate}} <span aria-hidden="true">↗</span></a></div>
    <div class="login-form-wrap">
      <h2>{{'FORGOT_PASSWORD.TITLE' | translate}}</h2>
      <p class="login-subtitle">{{'FORGOT_PASSWORD.SUBTITLE' | translate}}</p>
      <form [formGroup]="recoverPassFormGroup" (ngSubmit)="recoverPass()" novalidate>
        <div class="login-field">
          <label for="recover-email">{{'REGISTER_PAGE.EMAIL_INPUT' | translate}}</label>
          <input id="recover-email" type="email" formControlName="mail" autocomplete="username" placeholder="{{'REDESIGN.UI.EMAIL_PLACEHOLDER' | translate}}" [attr.aria-invalid]="recoverPassFormGroup.get('mail').touched && recoverPassFormGroup.get('mail').invalid">
          <span class="login-error" *ngIf="recoverPassFormGroup.get('mail').touched && recoverPassFormGroup.get('mail').invalid">{{'REDESIGN.EMAIL_REQUIRED' | translate}}</span>
        </div>
        <button type="submit" class="login-submit">{{'FORGOT_PASSWORD.SUBMIT' | translate}} <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg></button>
      </form>
      <a routerLink="/login" class="login-back"><span aria-hidden="true">←</span> {{'FORGOT_PASSWORD.BACK' | translate}}</a>
    </div>
    <footer><span>© {{year}} Innporting</span><a href="https://innporting.com/legal-notice-conditions" target="_blank" rel="noopener noreferrer">{{'FOOTER.TERMS_AND_CONDITIONS' | translate}}</a></footer>
  </main>
</div>
